import {useEffect, useState} from 'react';

import {useCurrentUserState} from 'app/current-user/api';

import {
  dataRangeTemplatesMap,
  DateRangeTemplateType,
  DateRangeType,
  getDateRangeTitle,
  getValidRangeTemplate,
  VALID_RANGE_TEMPLATE,
} from './utils';

export function useDateRange({
  initialValue,
  templates = [],
}: {
  initialValue: string;
  templates: Array<VALID_RANGE_TEMPLATE>;
}): {
  rangeTemplates: Array<DateRangeTemplateType>;
  selectedRangeTemplate: VALID_RANGE_TEMPLATE;
  selectRangeTemplate: (template: VALID_RANGE_TEMPLATE) => unknown;
  customRange: DateRangeType;
  selectCustomRange: (range: DateRangeType) => unknown;
  getCustomRangeTitle: () => string;
  getRangeTitle: () => string;
  userTz: string;
} {
  const [selectedRangeTemplate, selectRangeTemplate] =
    useState<VALID_RANGE_TEMPLATE>(getValidRangeTemplate(initialValue));

  const [customRange, selectCustomRange] = useState<DateRangeType>({
    start: '',
    end: '',
  });

  const userTz = useCurrentUserState().data!.timezone;

  const rangeTemplates: Array<DateRangeTemplateType> =
    templates.map<DateRangeTemplateType>((k) => dataRangeTemplatesMap[k]);

  useEffect(() => {
    const template = dataRangeTemplatesMap[selectedRangeTemplate];
    selectCustomRange(template.build(userTz, customRange));
  }, [selectedRangeTemplate]);

  const getCustomRangeTitle = () => getDateRangeTitle(customRange, userTz);

  const getRangeTitle = () =>
    selectedRangeTemplate !== 'custom'
      ? dataRangeTemplatesMap[selectedRangeTemplate].label()
      : getCustomRangeTitle();

  return {
    rangeTemplates,
    selectedRangeTemplate,
    selectRangeTemplate,
    customRange,
    selectCustomRange,
    getCustomRangeTitle,
    getRangeTitle,
    userTz,
  };
}
